export const SET_USER_PROFILE = 'SET_USER_PROFILE'
